<template>
  <template v-if="stringArray.length > 0 && !isLoading">
    <span
      v-for="(scoreString, index) in stringArray"
      :key="index"
      :class="isAnimated ? ['number-animation', 'relative'] : ''"
    >
      <Img
        v-if="scoreString === ','"
        :src="`${patternImgSrc}_${sizeLabel}_11.svg`"
        alt="カンマ"
      />
      <Img
        v-else-if="scoreString === '0'"
        :src="`${patternImgSrc}_${sizeLabel}_10.svg`"
        :alt="scoreString"
        :class="
          isAnimated
            ? `number-animation__score number-animation__score--${
                stringArray.length - 1 - index
              }`
            : ''
        "
      />
      <Img
        v-else
        :src="`${patternImgSrc}_${sizeLabel}_0${scoreString}.svg`"
        :alt="scoreString"
        :class="
          isAnimated
            ? `number-animation__score number-animation__score--${
                stringArray.length - 1 - index
              }`
            : ''
        "
      />
      <Img
        v-if="isAnimated"
        :src="`${patternImgSrc}_anim_0${index + 1}.png`"
        :alt="scoreString"
        :class="`number-animation__item absolute number-animation__item--${
          stringArray.length - 1 - index
        } left-0 top-0`"
        :width="28"
        :height="40"
      />
    </span>
  </template>
  <template v-else>
    <span
      ><Img :src="`${patternImgSrc}_${sizeLabel}_12.svg`" alt="記録なし"
    /></span>
    <span><Img :src="`${patternImgSrc}_${sizeLabel}_12.svg`" alt="" /></span>
  </template>
</template>

<script setup lang="ts">
interface Props {
  stringArray: string[];
  size: 'medium' | 'large';
  pattern?: 'score' | 'evolution';
  isAnimated?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  isAnimated: false,
  pattern: 'score',
});

const { isLoading } = useLoading();
const sizeLabel = computed(() => (props.size === 'medium' ? 'm' : 'l'));
const patternImgSrc = computed(() => {
  switch (props.pattern) {
    case 'score':
      return '/images/ranking/number/number';
    case 'evolution':
      return '/images/ranking/number/number_exam';
    default:
      return '';
  }
});
</script>

<style scoped>
.number-animation__score {
  opacity: 0;
  animation: fadeIn 0s ease forwards;
}
.number-animation__score--0 {
  animation-delay: 0.8s;
}
.number-animation__score--1 {
  animation-delay: 1.3s;
}
.number-animation__score--2 {
  animation-delay: 1.8s;
}

.number-animation__item {
  opacity: 1;
  animation: fadeout 0s ease forwards;
}

.number-animation__item--0 {
  animation-delay: 0.8s;
}
.number-animation__item--1 {
  animation-delay: 1.3s;
}
.number-animation__item--2 {
  animation-delay: 1.8s;
}

@keyframes fadeIn {
  100% {
    opacity: 1;
  }
}
@keyframes fadeout {
  100% {
    opacity: 0;
  }
}
</style>
